import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { SupportChat } from './SupportChat';

// Nav items. In an embedded app these render inside the Shopify Admin sidebar
// via the App Bridge <ui-nav-menu> web component (like BundleMaster) — the app
// no longer draws its own Polaris Frame sidebar.
const NAV_ITEMS = [
  { url: '/', label: 'Dashboard' },
  { url: '/onboarding', label: 'Getting started' },
  { url: '/products', label: 'Products' },
  { url: '/orders', label: 'Orders' },
  { url: '/expenses', label: 'Expenses' },
  { url: '/reports', label: 'Reports' },
  { url: '/ad-spend', label: 'Ad Spend' },
  { url: '/alerts', label: 'Alerts' },
  // Integrations (Facebook/Google/TikTok/ShipStation) hidden until ad-platform
  // credentials are configured — Connect/Sync can't work without them.
  { url: '/settings', label: 'Settings' },
  { url: '/billing', label: 'Billing' },
];

// Embedded = running inside the Shopify Admin iframe. When standalone (dev at the
// tunnel URL) App Bridge isn't active, so ui-nav-menu renders nothing — we show a
// simple top nav bar instead so local testing still has navigation.
const isEmbedded = window.top !== window.self;

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <>
      {/* App Bridge nav — renders as the ProfitVault submenu in the Shopify Admin
          sidebar. The rel="home" link marks the app root (not shown as an item). */}
      <ui-nav-menu>
        <a href="/" rel="home">
          ProfitVault
        </a>
        {NAV_ITEMS.map((item) => (
          <a key={item.url} href={item.url}>
            {item.label}
          </a>
        ))}
      </ui-nav-menu>

      {!isEmbedded && (
        <nav
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            flexWrap: 'wrap',
            padding: '10px 20px',
            borderBottom: '1px solid #e1e3e5',
            background: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 100,
          }}
        >
          <strong style={{ marginRight: 16, fontSize: 15 }}>ProfitVault</strong>
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.url}
              to={item.url}
              end={item.url === '/'}
              style={({ isActive }) => ({
                padding: '6px 12px',
                borderRadius: 8,
                textDecoration: 'none',
                fontSize: 14,
                color: isActive ? '#fff' : '#303030',
                background: isActive ? '#303030' : 'transparent',
              })}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      )}

      {children}

      <SupportChat />
    </>
  );
}
